export default {
  key: "sucesso",
  Things: "Le cose",
  "Upload Date": "Data di caricamento",
  Duration: "Durata",
  Features: "Caratteristiche",
  "Edit Image": "Modifica immagine",
  Title: "Titolo",
  Description: "Descrizione",
  "New Image": "Nuova immagine",
  Image: "Immagine",
  Images: "immagini",
  Tags: "Tag",
  "Save & close": "Salva e chiudi",
  Type: "Tipo",
  Edit: "Modificare",
  Delete: "Elimina",
  "Go back": "Torna indietro",
  "New item": "Nuovo oggetto",
  Id: "Id",
  "Upload Image": "Carica immagine",
  "Layouts Timeline": "Cronologia dei layout",
  Date: "Data",
  "Back stage": "Dietro le quinte",
  Front: "Davanti",
  items: "Oggetti",
  "Navigate: Things": "Naviga: Cose",
  Orientation: "Orientamento",
  back: "Indietro",
  front: "davanti",
  gallery: "galleria",
  preview: "anteprima",
  New: "Nuovo",
  search: "ricerca",
};
